import { userApi } from "@/core/apis";

// getter types
export const USERS = "users";

// action types
export const GET_USERS = "getUsers";

// mutation types
const SET_USERS = "setUsers";

const state = {
  users: []
};

const getters = {
  [USERS](state) {
    return state.users;
  }
};

const actions = {
  [GET_USERS](context) {
    return new Promise(resolve => {
      userApi.getAllUsers().then(response => {
        context.commit(SET_USERS, response);

        resolve();
      });
    });
  }
};

const mutations = {
  [SET_USERS](state, users) {
    state.users = users;
  }
};

export default {
  state,
  actions,
  mutations,
  getters
};
